import { Component, OnInit, Input } from '@angular/core';

import { AppComponent } from '../app.component';
import { ViewEncapsulation } from '@angular/core'

@Component({
  standalone: false,
  selector: 'pnl-default',
  templateUrl: './z-pnl-default.component.html',
  styleUrls: ['./z-pnl-default.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class pnlDefault implements OnInit {

  @Input() aPanelData: any;

  constructor( public app: AppComponent ) { }

  ngOnInit() {
  }

}
